import styled from 'styled-components';
import { colours, fonts } from 'themes/default';
const { fontStyleRegular } = fonts;

const StyledSelect = styled.select`
  ${fontStyleRegular}
  border: 1px solid ${colours.Shades.TintBlue10};
  background-color: ${colours.Greyscale.White};
  border-radius: 6px;
  height: 30px;

  &:focus {
    box-shadow: 0 0 0 1px ${colours.Core.CoreNavy};
    outline: none;
  }
`;
export default StyledSelect;
